angular.module("avant.customer_applications.directives").directive "regexRestrict", ['$parse', ($parse) ->
  restrict: 'A'
  require: 'ngModel'
  link: (scope, element, attributes, controller) ->
    scope.$watch attributes.ngModel, (value) ->
      matcher = new RegExp attributes.regexRestrict, 'g'
      if value and matcher
        $parse(attributes.ngModel).assign(scope, value.replace(matcher, ''))
]